<template>
  <modal
    :show="show"
    classes="main-modal"
    bodyClass="rating-modal"
    @onHide="onHide"
  >
    <template v-if="loading">
      <v-loader></v-loader>
    </template>
    <template v-if="!loading && !successMessage">
      <div class="rating-modal__title">
        <span>{{ data.title }}</span>
      </div>
      <div class="rating-modal__fields">
        <template v-for="(field, index) in data.fields">
          <input-rating
            @change="changeValue"
            :data="field"
            :key="index"
          ></input-rating>
        </template>
      </div>
      <div class="rating-modal__button d-flex justify-content-end">
        <v-button class="primary" @click="submitRequest">
          <img :src="require('@/assets/icons/check-square.svg')" />
          <span>Enviar</span>
        </v-button>
      </div>
    </template>
    <div class="rating-modal-success" v-if="successMessage">
      <img src="static/success-icon.svg" alt="" />
      <div class="rating-modal-success__title">
        <span>Obrigado por sua avaliação!</span>
      </div>
      <div class="rating-modal-success__subtitle">
        <span
          >Seu feedback é muito importante para buscarmos a excelência. Conte
          sempre conosco!</span
        >
      </div>

      <div class="rating-modal-success__btn">
        <v-button @click="onHide">
          Fechar
        </v-button>
      </div>
    </div>
  </modal>
</template>
<script>
import InputRating from '@/parts/components/rating/input'
import Modal from '@/parts/components/modal'

import RatingApi from '@/api/rating'

export default {
  name: 'RatingModal',
  components: {
    InputRating,
    Modal
  },
  props: {
    show: Boolean,
    data: {},
    loading: Boolean,
    requestName: String,
    contractId: Number
  },
  data() {
    return {
      payload: {
        fields: {}
      },
      successMessage: false
    }
  },
  methods: {
    submitRequest() {
      const user = this.$store.getters.user
      this.loading = true
      this.payload.rating_id = this.data.rating_id
      if (user.type === 'vibbrante') {
        this.payload.vibbrante_id = user.id
      } else {
        this.payload.client_id = user.id
      }

      if (this.contractId) this.payload.contract_id = this.contractId

      RatingApi.submit_rating(this.payload)
        .then(() => {
          this.successMessage = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeValue(data) {
      this.payload.fields[data.field_id] = data.value
    },
    onHide() {
      this.show = false
      this.successMessage = false
      this.payload = { fields: {} }
      this.$emit('onHide')
    }
  }
};
</script>

<style lang="scss">
.main-modal {
  max-width: 597px;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  height: 560px;
  overflow-y: hidden !important;
  border-radius: 10px;

  .close {
    display: none;
  }
   @media screen and (max-width: 750px) {
     width: 100%!important;
     bottom: toRem(1px)!important;
     top: initial !important;
     transform: translate(-50%, 0)!important;;
   }
}

.rating-modal {
  padding: 40px 60px !important;
  @media screen and (max-width: 550px) {
    padding: 15px 20px !important;
  }

  &__title {
    color: var(--Vibbra-Color-Styles-Grey-grey-700, #1f1f1f);
    /* font-family: Montserrat;  */
    font-size: toRem(22px);
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  }

  &__fields {
    margin-top: 40px;
  }

  &__button {
    margin-top: 45px;

    button {
      border-radius: 10px;
      height: 44px;
      font-size: 12px;

      span {
        font-weight: bold;
      }

      img {
        padding-right: 10px;
      }
    }
  }
}

.rating-modal-success {
  &__title {
    margin-top: 15px;
    > span {
      font-weight: bold;
    }
  }

  &__subtitle {
    > span {
      color: #949494;
      font-weight: 400;
      font-size: 14px;
    }
  }

  &__btn {
    margin-top: 15px;
    > button {
      width: 100%;
      border: 1px solid #949494;
      font-weight: 800;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/modals/rating-modal.vue